import React, { useEffect } from 'react';
import { Card, SkeletonImage } from '@bynder/design-system';
import { IconPlaceholder } from '@bynder/icons';
import { PartialComponent } from 'packages/services/ComponentService';
import { useComponentThumbnail } from '../useComponentThumbnail';

interface Props {
    component: PartialComponent;
    onRefreshReady?: (refresh: () => void) => void;
}

const ComponentThumbnail = ({ component, onRefreshReady }: Props) => {
    const { thumbnailUrl, isLoading, error, refresh } = useComponentThumbnail(component);

    useEffect(() => {
        onRefreshReady?.(refresh);
    }, [refresh, onRefreshReady]);

    if (isLoading) {
        return <SkeletonImage />;
    }

    if (error || !thumbnailUrl) {
        return (
            <Card.IconPlaceholder>
                <IconPlaceholder />
            </Card.IconPlaceholder>
        );
    }

    return (
        <Card.Images>
            <Card.Img src={thumbnailUrl} contentResize="fit" />
        </Card.Images>
    );
};

export default ComponentThumbnail;
